import InputField from "@/components/form/InputField";
import CheckboxField from "@/components/form/CheckboxField";
import * as Yup from "yup";

export const richTextValidationSchema = {
  options: Yup.object()
    .nullable()
    .shape({
      rich_text: Yup.object()
        .nullable()
        .shape({
          rows: Yup.number()
            .nullable()
            .min(1, "Must have at least 1 row")
            .max(50, "Cannot exceed 50 rows"),
          enable_markdown: Yup.boolean().nullable(),
        }),
    }),
};

export default function RichTextDisplayOptions() {
  return (
    <div>
      <InputField name="options.rich_text.rows" label="Rows" type="number" />
      <CheckboxField
        name="options.rich_text.enable_markdown"
        label="Enable Markdown Support"
      />
    </div>
  );
}
